/** The empty-page hint and the "+ Add widget" button; the picker itself is Inserter. */

import type { ReactNode } from 'react';

/** Shown on an empty widget page: the first thing to do there. */
export function EmptyPageHint({ show, onAdd }: { show: boolean; onAdd: () => void }): ReactNode {
  if (!show) return null;
  return (
    <div className="rb-empty">
      <p>This page is empty. Add a metric, a chart or a note for your client.</p>
      <button type="button" className="btn" onClick={onAdd}>
        Add a widget
      </button>
    </div>
  );
}

export function AddWidgetButton({ onAdd }: { onAdd: () => void }): ReactNode {
  return (
    <button type="button" className="rb-add" onClick={onAdd}>
      + Add widget
    </button>
  );
}
